/**
 * Seamly Channel API
 * The API for Seamly Channel REST API <br/><br/> **Please note**: You can view which schemas apply to an endpoint by navigating to the response of an endpoint and then clicking on *Schema*, right next to *Example Value*. By default example values are shown for each response.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@seamly.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MessageIncomingPayload } from './message-incoming-payload';

/**
 * A message from the bot / livechat service to the user (fromClient = false). Messages sent from the client (see MessageOutgoing) are also returned over the websocket, and are distinguishable by fromClient=true. See `MessageMessage` in the OpenAPI spec.
 */
export interface MessageIncoming {
    type: MessageIncoming.TypeEnum;
    payload: MessageIncomingPayload;
}
export namespace MessageIncoming {
    export type TypeEnum = 'message';
    export const TypeEnum = {
        Message: 'message' as TypeEnum
    };
}
